import React from "react";
import styles from "../Modules/Navbar.module.css";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
require("../index.css");

const NAV_LINKS = [
  { label: "Home",      to: "home"     },
  { label: "Projects",  to: "projects" },
  { label: "Articles",  to: "writing"  },
  { label: "About Me",  to: "aboutme"  },
  { label: "Contact",   to: "contact"  },
];

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
      menuOpen: false,
    };
    this.handleScroll  = this.handleScroll.bind(this);
    this.handleResize  = this.handleResize.bind(this);
    this.toggleMenu    = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }

  handleScroll() {
    this.setState({ scrolled: window.scrollY > 20 });
  }

  handleResize() {
    if (window.innerWidth > 601) {
      this.setState({ menuOpen: false });
    }
  }

  toggleMenu() {
    this.setState((prev) => ({ menuOpen: !prev.menuOpen }));
  }

  render() {
    const { scrolled, menuOpen } = this.state;

    return (
      <nav
        id="mynavbar"
        className={`${styles.navbar} ${scrolled ? styles.scrolled : ""} ${menuOpen ? styles.expanded : ""}`}
      >
        <div className={styles.inner}>
          {/* Brand */}
          <Link
            className={styles.brand}
            to="home"
            spy={true}
            smooth={true}
            offset={0}
            duration={800}
          >
            <span className={styles.brandBadge}>SE</span>
            <span className={styles.brandName}>Soulaimane</span>
          </Link>

          {/* Desktop links */}
          <ul className={styles.links}>
            {NAV_LINKS.map(({ label, to }) => (
              <li key={to}>
                <Link
                  className={styles.link}
                  to={to}
                  activeClass={styles.active}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Hamburger */}
          <button className={styles.hamburger} onClick={this.toggleMenu} aria-label="Toggle menu">
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>
        </div>

        {/* Mobile dropdown */}
        {menuOpen && (
          <ul className={styles.mobileMenu}>
            {NAV_LINKS.map(({ label, to }) => (
              <li key={to}>
                <Link
                  className={styles.mobileLink}
                  to={to}
                  activeClass={styles.mobileActive}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
                  onClick={() => this.setState({ menuOpen: false })}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </nav>
    );
  }
}

export default Navbar;
